module.exports = __webpack_public_path__ + "media/images/metronic/social/blogger-57456685f86380431c4967b9434e2476.png";